/**
 * This utility has been written to safeguard against potential regex denial of service attack - ReDoS.
 * The Regular expression Denial of Service (ReDoS) is a Denial of Service attack, that exploits the fact that most Regular Expression implementations may reach extreme situations that cause them to work very slowly (exponentially related to input size).
 * An attacker can then cause a program using a Regular Expression (Regex) to enter these extreme situations and then hang for a very long time.
 */

/**
 * ^ asserts the start of the string
 * [ and ] are used to define a character class
 * \\ allows a literal backslash
 * a-zA-Z0-9 allows any alphanumeric character
 * '";:, allows specific other characters
 * | allows for OR
 * . any character except newline or period
 * - allows ranges
 * + allows any number of the specified characters
 * * allows any number (including zero) of the specified characters.
 * $ asserts the end of the string
 * ' ' space
 */
const defaultSafeCharacters = /^[\\a-zA-Z0-9\-'" .,;:^$*+|[\]]*$/;
export const RegexSafetyLevels = {
  DEFAULT: {
    maxLength: 20,
    safeCharacters: defaultSafeCharacters,
    maxConsecutiveSpecialChars: 3,
    specialCharacters: '[]|*+'
  }
};
export const isRegex = value => value.startsWith('/') && value.endsWith('/') && value.length > 2;
export const isSafeRegexUserInput = (input, {
  maxLength,
  safeCharacters,
  maxConsecutiveSpecialChars,
  specialCharacters
}) => {
  // Prevent regex from being an invalid length
  if (input.length === 0 || input.length > maxLength) {
    return false;
  }

  // Prevent regex from containing invalid and disallowed characters
  if (!safeCharacters.test(input.substring(1, input.length - 1))) {
    return false;
  }

  // Prevent regex from having too many consecutive special characters to reduce complexity
  for (let i = 0; i < input.length - 1; i++) {
    if (specialCharacters.includes(input[i]) && specialCharacters.includes(input[i + 1])) {
      if (i + maxConsecutiveSpecialChars < input.length && specialCharacters.includes(input[i + maxConsecutiveSpecialChars])) {
        return false;
      }
    }
  }
  return true;
};